// Stable key for the §3.7 scale keyboard done-set (engine v2). The done
// marks live in localStorage keyed by message — but the LIVE message is
// stamped with the client clock while the same row returns the server
// created_at from /history after a reload, so a timestamp key would let an
// ANSWERED keyboard resurrect. Content is identical on both paths (the
// engine's repeat_reply rail forbids verbatim duplicate replies), so a
// content-derived hash keys both sides to the same value.

export function scaleKey(content: string): string {
  // FNV-1a 32-bit — deterministic, no deps, collision-safe for this scale
  let h = 0x811c9dc5
  for (let i = 0; i < content.length; i++) {
    h ^= content.charCodeAt(i)
    h = Math.imul(h, 0x01000193)
  }
  return (h >>> 0).toString(36)
}
